"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Header = function Header(_ref) {
  var logo = _ref.logo,
      actionButton = _ref.actionButton,
      _ref$withLogin = _ref.withLogin,
      withLogin = _ref$withLogin === void 0 ? false : _ref$withLogin;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
    className: _styleModule.default.header,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      alignItems: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: withLogin ? 6 : 2,
        className: _styleModule.default.collumn1,
        children: logo
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: withLogin ? 6 : 10,
        className: _styleModule.default.collumn2,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          className: _styleModule.default.content,
          children: actionButton
        })
      })]
    })
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(Header);

exports.default = _default;